import { taskApi } from "api/tasks/taskApi";

const TASK_GROUP_FALLBACK = "Ungrouped";

const getTaskId = (task) => task?.task_id ?? task?.task ?? task?.id ?? null;

export const normalizeLinkedTaskForSelection = (task) => {
  const taskId = getTaskId(task);

  return {
    ...task,
    id: taskId,
    task: taskId,
    item_name: task?.item_name || task?.task_name || "Untitled task",
    sectionName: task?.task_group || TASK_GROUP_FALLBACK,
    status: task?.status || task?.task_status,
    task_details: {
      ...(task?.task_details || {}),
      id: taskId,
      task_status: task?.task_status || task?.task_details?.task_status,
      status: task?.status || task?.task_details?.status,
    },
  };
};

export const getLinkedTasksBySite = async (siteId) => {
  const tasks = await taskApi.getTasksBySite(siteId);

  return (Array.isArray(tasks) ? tasks : [])
    .filter((task) => task?.is_linked === true)
    .map(normalizeLinkedTaskForSelection);
};
